export default {
    state: {
        suppliers: [],
    },
    mutations: {
        setSuppliers(state, users) {
            state.suppliers = users
        },
        addSupplier(state, user) {
            state.suppliers.push(user)
        },
        updateSupplier(state, location) {
            const index = state.suppliers.findIndex(item => item.id === location.id)
            Vue.set(state.suppliers, index, location)
        },
        removeSupplier(state, manufacturerId) {
            state.suppliers = state.suppliers.filter(item => item.id !== manufacturerId)
        },
    },
    getters: {
        listSuppliers: state => state.suppliers,
        findSupplier: state => id => state.suppliers.find(item => item.id === id)
    },
    actions: {
        loadSuppliers(context) {
            window.axios.get('/api/suppliers')
                .then(({ data }) => {
                    context.commit('setSuppliers', data)
                })
                .catch(error => console.error(error))
        },
        addSupplier(context, payload) {
            context.commit('addSupplier', payload)
        },
        updateSupplier(context, payload) {
            context.commit('updateSupplier', payload)
        },
        removeSupplier(context, userId) {
            context.commit('removeSupplier', userId)
        },
    }
}
